import { Box, IconButton, Tooltip } from "@mui/material"
import { useContext, useEffect, useMemo, useState } from "react";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import AgGridTable from "../utilities/AgGridTable";
import GroupRowInnerRenderer from "./GroupRowInnerRenderer";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import { handleErrorMsg, handleSuccessMsg } from "./OkrPerformance";

const CheckSubmiitedOKR = () => {
    const showPercentage = (props) => {
        return props.value && (props.value + '%')
    }
    const [submittedData, setSubmittedData] = useState([]);
    const [mailsentList, setMailSentList] = useState([]);
    const [successMsg, setSuccessMsg] = useContext(handleSuccessMsg)
    const [error, setError] = useContext(handleErrorMsg)
    const [notSubmittedcolumnDefs, setNotSubmittedColumnDefs] = useState([]);
    const [columnDefs, setColumnDefs] = useState([
        { field: 'Group', editable: false },
        { field: 'empDepartment', rowGroup: true, hide: true },
        {
            field: 'isCommentAdded',
            hide: true,
            rowGroup: true,
            headerName: 'Update Submitted'
        },
        { field: 'employeeEmail', rowGroup: true, hide: true },
        { field: 'quarterly', rowGroup: true, hide: true },
        {
            field: 'objectiveValue',
            headerName: 'Objectives',
            enableRowGroup: true,
            rowSpan: function (params) {
                if (params?.data?.objectiveValue !== undefined) {
                    return params?.data?.objlength;
                } else {
                    return 1;
                }
            },
            minWidth: '250',
            type: 'editableColumn',
            cellClassRules: {
                'show-cell': "value !== undefined",
            },
            checkboxSelection: params => params?.data?.objectiveValue ? true : false
        },
        {
            field: 'keyResultValue',
            headerName: 'Objectives Key Results',
            type: 'editableColumn',
            minWidth: '400',
        },
        {
            field: 'deadLine', enableRowGroup: true,
            type: 'editableColumn',
        },
        {
            field: 'weightagePercentage', enableRowGroup: true,
            type: 'editableColumn',
            valueFormatter: showPercentage
        },
        {
            field: 'grading', enableRowGroup: true,
            type: 'editableColumn',
            valueFormatter: showPercentage,
            minWidth: 90,
        },
        {
            field: 'finalWeightedPercentage', enableRowGroup: true,
            type: 'editableColumn',
            editable: false,
            valueFormatter: showPercentage
        },
    ]);


    const okrurl = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.performance}`;

    const getSubmittedOKR = async () => {
        try {
            let okrData = [];
            let queryParams = '';
            const getlist = await OAuthService.getList(okrurl + `/getAllOkr`);
            getlist?.data && getlist?.data?.map((data) => {
                let objects = {
                    "okrid": data.id,
                    "employeeEmail": data.employeeEmail,
                    "empDepartment": data.empDepartment,
                    'okrStatus': data?.okrStatus,
                    'year': data?.year,
                    'quarterStartDate': data?.quarterStartDate,
                    'dueDate': data?.dueDate,
                    'weekDuration': data?.weekDuration,
                    'startDate': data?.startDate,
                    'endDate': data?.endDate,
                    'quarterly': data.quarterly,
                    'isDraft': data.isDraft,
                    'isCommentAdded': data.isCommentAdded,
                };
                if (data.isCommentAdded === true && data?.objective.length > 0) {
                    if (data?.objective.length > 0) {
                        data?.objective?.map((obj, key) => {
                            objects = {
                                ...objects,
                                'objId': obj.id,
                                'objlength': Object.keys(obj?.keyResult).length
                            }
                            delete objects.deadLine;
                            delete objects.keyResultValue;
                            delete objects.weightagePercentage;
                            delete objects.grading;
                            delete objects.finalWeightedPercentage;
                            delete objects.objectiveValue;
                            delete objects.resultId;
                            delete objects.status;
                            delete objects.comment;
                            delete objects.weekNo;
                            delete objects.updateNo;
                            delete objects.weekstartDate;
                            delete objects.weekendDate;
                            delete objects.statusId;
                            delete objects.createdAt;
                            delete objects.createdBy;
                            obj?.keyResult?.map((result, index) => {
                                if (index === 0) {
                                    objects = {
                                        ...objects,
                                        "deadLine": result.deadLine,
                                        "keyResultValue": result.keyResultValue,
                                        "weightagePercentage": result.weightagePercentage,
                                        "grading": result.grading,
                                        "finalWeightedPercentage": result.finalWeightedPercentage,
                                        "objectiveValue": obj.objectiveValue,
                                        'resultId': result.id
                                    }
                                } else {
                                    objects = {
                                        ...objects,
                                        "deadLine": result.deadLine,
                                        "keyResultValue": result.keyResultValue,
                                        "weightagePercentage": result.weightagePercentage,
                                        "grading": result.grading,
                                        "finalWeightedPercentage": result.finalWeightedPercentage,
                                        "objectiveValue": undefined,
                                        'resultId': result.id
                                    }
                                }
                                delete objects.status;
                                delete objects.weekNo;
                                delete objects.updateNo;
                                delete objects.weekstartDate;
                                delete objects.weekendDate;
                                delete objects.comment;
                                delete objects.statusId;
                                delete objects.createdAt;
                                delete objects.createdBy;
                                result.keyResultStatus && result.keyResultStatus.map((keyStatus, k) => {
                                    if (k === (result.keyResultStatus.length - 1)) {
                                        objects = {
                                            ...objects,
                                            "status": keyStatus.status,
                                            "comment": keyStatus.comment,
                                            'statusId': keyStatus.id,
                                            'createdAt': keyStatus.createdAt,
                                            'weekNo': keyStatus.weekNo,
                                            'updateNo': keyStatus.updateNo,
                                            'weekstartDate': keyStatus.startDate,
                                            'weekendDate': keyStatus.endDate,
                                            'createdBy': keyStatus.createdBy
                                        }
                                    }
                                    return
                                })
                                okrData.push(objects)
                            })
                        })
                    } else {
                        okrData.push(objects)
                    }
                }
            });
            setSubmittedData(okrData)
        } catch (error) {
        }
    }

    const getNotSubmittedOKR = async () => {
        try {
            let okrData = [];
            let mailList = [];
            let queryParams = '';
            const getlist = await OAuthService.getList(okrurl + `/getAllOkr`);

            getlist?.data && getlist?.data?.map((data) => {
                let objects = {
                    "okrid": data.id,
                    "employeeEmail": data.employeeEmail,
                    "empDepartment": data.empDepartment,
                    'okrStatus': data?.okrStatus,
                    'year': data?.year,
                    'quarterStartDate': data?.quarterStartDate,
                    'dueDate': data?.dueDate,
                    'weekDuration': data?.weekDuration,
                    'startDate': data?.startDate,
                    'endDate': data?.endDate,
                    'quarterly': data.quarterly,
                    'isDraft': data.isDraft,
                    'isCommentAdded': data.isCommentAdded,
                };
                const diff = new Date(data?.dueDate) - new Date();
                const diffDays = Math.ceil(diff / (1000 * 60 * 60 * 24));
                if (data.isCommentAdded === false && diffDays <= 3) {
                    if (data?.objective.length > 0) {

                        const now = new Date();
                        now.setHours(10, 0, 0, 0);
                        const futureDate = new Date().getTime();
                        const timeleft = new Date(data?.dueDate) === new Date() ? futureDate - now.getTime() : 1;

                        data?.objective?.map((obj, key) => {
                            objects = {
                                ...objects,
                                'objId': obj.id,
                                'objlength': Object.keys(obj?.keyResult).length
                            }
                            delete objects.deadLine;
                            delete objects.keyResultValue;
                            delete objects.weightagePercentage;
                            delete objects.grading;
                            delete objects.finalWeightedPercentage;
                            delete objects.objectiveValue;
                            delete objects.resultId;
                            delete objects.status;
                            delete objects.comment;
                            delete objects.weekNo;
                            delete objects.updateNo;
                            delete objects.weekstartDate;
                            delete objects.weekendDate;
                            delete objects.statusId;
                            delete objects.createdAt;
                            delete objects.createdBy;
                            obj?.keyResult?.map((result, index) => {
                                if (index === 0) {
                                    objects = {
                                        ...objects,
                                        "deadLine": result.deadLine,
                                        "keyResultValue": result.keyResultValue,
                                        "weightagePercentage": result.weightagePercentage,
                                        "grading": result.grading,
                                        "finalWeightedPercentage": result.finalWeightedPercentage,
                                        "objectiveValue": obj.objectiveValue,
                                        'resultId': result.id
                                    }
                                } else {
                                    objects = {
                                        ...objects,
                                        "deadLine": result.deadLine,
                                        "keyResultValue": result.keyResultValue,
                                        "weightagePercentage": result.weightagePercentage,
                                        "grading": result.grading,
                                        "finalWeightedPercentage": result.finalWeightedPercentage,
                                        "objectiveValue": undefined,
                                        'resultId': result.id
                                    }
                                }
                                delete objects.status;
                                delete objects.weekNo;
                                delete objects.updateNo;
                                delete objects.weekstartDate;
                                delete objects.weekendDate;
                                delete objects.comment;
                                delete objects.statusId;
                                delete objects.createdAt;
                                delete objects.createdBy;
                                result.keyResultStatus && result.keyResultStatus.map((keyStatus, k) => {
                                    if (k === (result.keyResultStatus.length - 1)) {
                                        objects = {
                                            ...objects,
                                            "status": keyStatus.status,
                                            "comment": keyStatus.comment,
                                            'statusId': keyStatus.id,
                                            'createdAt': keyStatus.createdAt,
                                            'weekNo': keyStatus.weekNo,
                                            'updateNo': keyStatus.updateNo,
                                            'weekstartDate': keyStatus.startDate,
                                            'weekendDate': keyStatus.endDate,
                                            'createdBy': keyStatus.createdBy
                                        }
                                    }
                                    return
                                })
                                okrData.push(objects)
                                if(mailList.length > 0) {
                                    const filter = mailList.filter((list) => list.okrId === data.id);
                                    if(filter.length === 0){
                                        mailList.push({
                                            "okrId": data.id,
                                            duration: timeleft === 0 ? timeleft : diffDays,
                                            durationType: timeleft === 0 ? 'hour' : 'days',
                                            dueDate: data?.dueDate
                                        })
                                    }
                                }else{
                                    mailList.push({
                                        "okrId": data.id,
                                        duration: timeleft === 0 ? timeleft : diffDays,
                                        durationType: timeleft === 0 ? 'hour' : 'days',
                                        dueDate: data?.dueDate
                                    })
                                }
                            })
                        })
                    } else {
                        okrData.push(objects)
                    }
                }
            });
            setMailSentList(mailList);
            setNotSubmittedColumnDefs(okrData)
        } catch (error) {
        }
    }

    useEffect(() => {
        getSubmittedOKR();
        getNotSubmittedOKR();
    }, [])

    const groupRowRendererParams = useMemo(() => {
        return {
            innerRenderer: GroupRowInnerRenderer,
            checkbox: true,
            groupUseEntireRow: true,
            suppressCount: true
        }
    });

    const handleSendMail = async() => {
        try {
            await Promise.all(mailsentList.map(async(mail) => {

                const data = {
                  "okrId": mail.okrId,
                  "duration": mail.duration,
                  "durationType": mail.durationType,
                  "dueDate": mail.dueDate
                }
                const sendMail = await OAuthService.addData(okrurl + '/sendNotification', data)
                if (sendMail?.data) {
                  setSuccessMsg("Mail sent successfully.")
                }
            }))
          } catch (error) {
            setError(error.message)
          }
    }

    return <div className="flex flex-col sm:flex-row flex-1 w-full items-center justify-evenly p-10"  >
        <div className="w-[45%]">
            <label className="text-lg font-bold mb-10">Submitted OKR</label>
            <Box
                sx={{
                    border: '2px solid grey',
                    // overflowY: "auto",
                    marginTop: '10px'
                }}
                id="target"

            >
                <div className="h-[500px]">
                    <AgGridTable
                        columnDefs={columnDefs}
                        editable={false}
                        rowData={submittedData}
                        groupRowMinWidth={250}
                        hideCheckbox={true}
                        groupDisplayType={'groupRows'}
                        suppressRowTransform={true}
                        groupAllowUnbalanced={true}
                        groupRowRendererParams={groupRowRendererParams}
                    />
                </div>

            </Box>
        </div>
        <div className="w-[45%]">
            <label className="text-lg font-bold mb-10">Not Submitted OKR
                {mailsentList.length > 0 && <div className="float-right">
                    <Tooltip title={'Send Email'}>
                        <IconButton
                            size="small"
                            onClick={handleSendMail}
                        >
                            <FuseSvgIcon >heroicons-outline:mail</FuseSvgIcon>
                        </IconButton>
                    </Tooltip>
                </div>}
            </label>
            <Box
                sx={{
                    border: '2px solid grey',
                    // overflowY: "auto",
                    marginTop: '10px'
                }}
            >
                <div className="h-[500px]">
                    <AgGridTable
                        columnDefs={columnDefs}
                        editable={false}
                        rowData={notSubmittedcolumnDefs}
                        groupAllowUnbalanced={true}
                        groupDisplayType={'groupRows'}
                        groupRowRendererParams={groupRowRendererParams}
                        groupRowMinWidth={250}
                        suppressRowTransform={true}
                        hideCheckbox={true}
                    />

                </div>
            </Box>

        </div>
    </div>
}
export default CheckSubmiitedOKR